"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLayoutFooterBase = exports.AppLayoutFooter = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _utils = require("../../utils");
var _composeStencilComponent = require("../../utils/composeStencilComponent");
var _Row = _interopRequireDefault(require("../Row"));
var _helperComponents = require("./helperComponents");
var _core = require("@emotion/core");
var _excluded = ["children"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var AppLayoutFooterBase = function AppLayoutFooterBase(_ref) {
  var children = _ref.children,
    wrapperProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _core.jsx)(_helperComponents.ContentWrapper, {
    wrapperProps: wrapperProps
  }, children);
};
exports.AppLayoutFooterBase = AppLayoutFooterBase;
var AppLayoutFooter = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: AppLayoutFooterBase,
  displayName: 'AppLayoutFooter',
  description: 'The footer section of the layout, used for displaying copyright information, links to privacy policies, terms of service, and other content that should be consistently displayed at the bottom of the page.',
  propTypes: _objectSpread(_objectSpread({}, (0, _utils.omit)(_Row.default.describedPropTypes, ['children'])), {}, {
    children: _stencilReactDesc.PropTypes.node.description('Contains footer elements')
  })
});
exports.AppLayoutFooter = AppLayoutFooter;